import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface LoadingStateProps {
  /** Visible label shown to all users, e.g. "Loading risks..." */
  label?: string;
  /** Number of skeleton rows to render (default 5) */
  rows?: number;
  /** Height class for each skeleton row (default "h-10") */
  rowHeight?: string;
  /** Additional className for the outer container */
  className?: string;
}

/**
 * Accessible loading placeholder with visible text and aria-busy.
 * Wraps Skeleton rows with a status announcement for screen readers.
 */
export function LoadingState({
  label = "Loading...",
  rows = 5,
  rowHeight = "h-10",
  className,
}: LoadingStateProps) {
  return (
    <div
      className={cn("space-y-3", className)}
      aria-busy="true"
      aria-live="polite"
      role="status"
    >
      <p className="text-sm text-muted-foreground">{label}</p>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className={cn("w-full", rowHeight)} />
      ))}
    </div>
  );
}
